/** @format */

export const NotificatoinSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.67333 14.0067C6.67333 14.74 7.26667 15.3333 8 15.3333C8.73333 15.3333 9.32667 14.74 9.32667 14.0067H6.67333ZM8 4C9.84 4 11.3333 5.49333 11.3333 7.33333V12H4.66667V7.33333C4.66667 5.49333 6.16 4 8 4ZM8 1C7.44667 1 7 1.44667 7 2V2.78C4.90667 3.23333 3.33333 5.1 3.33333 7.33333V11.3333L2 12.6667V13.3333H14V12.6667L12.6667 11.3333V7.33333C12.6667 5.1 11.0933 3.23333 9 2.78V2C9 1.44667 8.55333 1 8 1Z"
                fill={color}
            />
        </svg>
    );
};
